import { copApi } from 'api'

export interface Experience {
  id: string
  name: string
  card?: unknown
  description?: string
  hoverText?: string
  order?: number
  isNew?: boolean
  color?: string
  skills?: unknown[]
}
export const fetchExperiences = () => copApi.get<Experience[]>('/digital-profile/high-level/experiences')
